export const IS_PHONEPE_ENABLED = false;
export const IS_RAZORPAY_ENABLED = false;
